'use client'

import { eventTypes } from '@lib/config'
import { htmlImgAddAlt } from '@lib/utils'
import clsx from 'clsx'
import { get, map } from 'lodash-es'
import { useTranslations } from 'next-intl'
import { Fragment, useState } from 'react'
import { House } from './card/house'
import { News } from './card/news'
import Chat from './chat'
import ShareButton from './shareButton'

export default function Description({ data }) {
  const ts = useTranslations('live')
  const [curTab, setCurTab] = useState(0)
  const tabs = [ts('description')]
  if (get(data, 'liveStream.chatRoomId') && get(data, 'liveStream.chatable') && data.eventType !== eventTypes.openCourse) tabs.push(ts('chat'))

  return (
    <section>
      <div className="mb-pix-10 flex items-center justify-between">
        <div className="flex gap-x-pix-20">
          {map(tabs, (tab, i) => (
            <button
              key={i}
              type="button"
              className={clsx(
                'relative text-f1.2 font-semibold bg-transparent after:mt-pix-4 after:block after:h-pix-4 after:w-full after:rounded-sm',
                curTab === i ? 'text-primary after:bg-primary' : 'text-c3b'
              )}
              onClick={() => setCurTab(i)}
            >
              {tab}
            </button>
          ))}
        </div>
        <ShareButton data={data} />
      </div>
      <div className={clsx('bg-white p-pix-20', { hidden: curTab !== 0 })}>
        <div className="text-f.9 font-medium">{data.name}</div>
        <div
          className="mt-pix-10 text-f.7 text-c3b"
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: htmlImgAddAlt(data.description) }}
        />
        <div className="mt-pix-20 flex flex-col gap-y-pix-20">
          {map(
            get(data, 'liveStream.liveRelates'),
            (item, idx) => (
              <Fragment key={idx}>
                {item.type === 'houses' && <House data={item} key={idx} />}
                {item.type === 'news' && <News data={item} key={idx} />}
              </Fragment>
            )
          )}
        </div>
      </div>
      <Chat data={data} show={curTab === 1} />
    </section>
  )
}
